import { render, staticRenderFns } from "./OpdrachtItem.vue?vue&type=template&id=67e211e4&scoped=true&"
import script from "./OpdrachtItem.vue?vue&type=script&lang=js&"
export * from "./OpdrachtItem.vue?vue&type=script&lang=js&"
import style0 from "./OpdrachtItem.vue?vue&type=style&index=0&id=67e211e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e211e4",
  null
  
)

export default component.exports